import { FC } from 'react';
import { translate } from 'src/locales/i18next/config';
import Translations from 'src/locales/i18next/translations/translation';

const Error404: FC = () => {
  const t = translate(Translations);
  const translation = 'modules.error.error404';
  return (
    <>
      <h1 className="fw-bolder fs-4x text-gray-700 mb-10">{t(`${translation}.notFound`)}</h1>

      <div className="fw-bold fs-3 text-gray-400 mb-15">
        {t(`${translation}.yourPageNotFound`)}
        <br />
        {t(`${translation}.differentPage`)}
      </div>
    </>
  );
};

export { Error404 };
